import React from 'react'
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/input/containers/input.container';

export default function GatewayRedisAndLogisticsInfoComponent({ handleFormChange, selectedGateway, domainsList }: any) {
  return (
    <>      
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
              label="Gateway"
              name="Gateway"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Logistics.Gateway',
                  selectedGateway?.Logistics
                )
              }}
              type="text"
              value={selectedGateway?.Logistics?.Gateway}
            />
            <InputContainer
              label="Registry"
              name="Registry"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Logistics.Registry',
                  selectedGateway?.Logistics
                )
              }}
              type="text"
              value={selectedGateway?.Logistics?.Registry}
            />
            <InputContainer
              label="BAP Id"
              name="BapId"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Logistics.BapId',
                  selectedGateway?.Logistics
                )
              }}
              type="text"
              value={selectedGateway?.Logistics?.BapId}
            />
            <InputContainer
              label="bap Url"
              name="BapUri"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Logistics.BapUri',
                  selectedGateway?.Logistics
                )
              }}
              type="text"
              value={selectedGateway?.Logistics?.BapUri}
            />
            <InputContainer
              label="bpp Id"
              name="BppId"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Logistics.BppId',
                  selectedGateway?.Logistics
                )
              }}
              type="text"
              value={selectedGateway?.Logistics?.BppId}
            />
            <InputContainer
              label="bpp Url"
              name="BppUri"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Logistics.BppUri',
                  selectedGateway?.Logistics
                )
              }}
              type="text"
              value={selectedGateway?.Logistics?.BppUri}
            />
            {/* <InputContainer
              label="Domain"
              name="Domain"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Logistics.Domain',
                  selectedGateway?.Logistics
                )
              }}
              type="text"
              value={selectedGateway?.Logistics?.Domain}
            /> */}
            <td
              className="px-6 pt-1 w-auto">
              <InputContainer
                label="Domain"
                name="Domain"
                labelField="Name"
                list={domainsList}
                onValueChange={(event: any) => {
                  handleFormChange(
                    event.target.value,
                    'Logistics.Domain',
                    selectedGateway?.Logistics
                  )
                }}
                type="select"
                value={selectedGateway?.Logistics?.Domain}
                valueField={"Code"}
              />
            </td>
            {/* <InputContainer
              label="Port"
              name="Port"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Logistics.Port',
                  selectedGateway?.Logistics
                )
              }}
              type="text"
              value={selectedGateway?.Logistics?.Port}
            /> */}
            <InputContainer
              label="Core Version"
              name="CoreVersion"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Logistics.CoreVersion',
                  selectedGateway?.Logistics
                )
              }}
              type="text"
              value={selectedGateway?.Logistics?.CoreVersion}
            />
          </div>
        }
        expandedPanel="Logistics Info"
        headerTitle="Network Logistics Settings"
      />

    </>
  )
}